import React, { useRef, useState } from "react";

const appId = "70002e84-8d04-4c25-9a47-1ba3d5ed6b26";
const daviAddress = 'https://demo-anghello-teams.davi.ai';
// const daviAddress = 'http://localhost:15151';
const emptyAddress = `https://login.microsoftonline.com/{TENANT_ID}/adminconsent?client_id={APP_ID}&state=12345&redirect_uri=${daviAddress}/permissions`;

interface Props {
  url: string;
}

const Home = ({ url }: Props) => {
  const [tenantId, setTenantId] = useState<string>("");
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClickTenant = (): void => {
    if (tenantId) {
      const address = emptyAddress.replace("{APP_ID}", appId).replace('TENANT_ID', tenantId);
      window.location.href = address;
    } else {
      alert("Aucun id de tenant renseigné");
    }
  };

  const handleChange = (): void => {
    setTenantId(inputRef?.current?.value || "");
  };

  const handleClickNext = (): void => {
    window.location.href = `${url}/sendnotification`
  };

  return (
    <div className="home">
      <h1>Page d'accueil</h1>

      <div className="home-container">
        <div className="home-consent">
          <div>Demande de consentement administrateur pour un tenant en particulier</div>
          <input ref={inputRef} className="home-text" type="text" value={tenantId} placeholder="id du tenant" onChange={handleChange}></input>
          <button className="home-button" onClick={handleClickTenant}>
            Lancer la demande
          </button>
        </div>

        <div className="home-consent">
          <div>Si le consentement administrateur a déjà été donné, passer à l'étape suivante</div>
          <button className="home-button" onClick={handleClickNext}>
            Etape suivante
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
